'use strict';exports.__esModule = true;var socialLinksData = exports.socialLinksData = [
{
  name: 'facebook',
  link: 'https://www.facebook.com/onmapltd/?ref=bookmarks' },

{
  name: 'twitter',
  link: 'https://twitter.com/OnMap_ltd' },

{
  name: 'linkedin',
  link: 'https://www.linkedin.com/company/onmap-ltd./' },

{
  name: 'youtube',
  link: 'https://www.youtube.com/channel/UCf0Rh1vmlIuWt4AMrFUH5xg' },

{
  name: 'instagram',
  link: 'https://www.instagram.com/onmap.co.il/?hl=en' }];



var desktopFooterLinks = exports.desktopFooterLinks = [
{
  name: 'about',
  link: 'about' },

{
  name: 'help',
  link: 'help' },

{
  name: 'publishProperty',
  link: 'publish' },

{
  name: 'contactUs',
  link: 'contact' },

{
  name: 'realtorContactUs',
  link: 'contact_us_realtor' },

{
  name: 'terms',
  link: 'terms' },

{
  name: 'privacy',
  link: 'privacy' },

{
  name: 'mobileApps',
  link: 'mobile_promotion' }];



var mobileFooterLinks = exports.mobileFooterLinks = [
{
  name: 'about',
  link: 'about' },

{
  name: 'contactUs',
  link: 'contact' },

{
  name: 'realtorContactUs',
  link: 'contact_us_realtor' },

{
  name: 'terms',
  link: 'terms' },

{
  name: 'privacy',
  link: 'privacy' },

{
  name: 'mobileApps',
  link: 'mobile_promotion' },

{
  name: 'help',
  link: 'help' },

{
  name: 'publishProperty',
  link: 'publish' }];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/config.js
// module id = 2657
// module chunks = 0